import { useLocaleState, useRecordContext } from "react-admin";

import LabelAttachedField from "../../unit/LabelAttachedField";
import LabelField from "../../unit/LabelField";
import Str from "../../unit/Str";
import { Grid } from "@mui/material";

const InitialReview = ({ ...props }) => {
  const { appId } = props;
  const record = useRecordContext();
  const [locale] = useLocaleState();
  if (!record) return null;

  const movestatus = "move " + record.fromstatus + " to " + record.tostatus;
  return (
    <>
      <Grid container spacing={1} sx={{ mb: 1 }}>
        <Grid item xs={12} md={6} lg={6}>
          <LabelField
            title="Date Reviewed"
            value={record.created_at}
            format="date"
            prefix="EST"
          />
          <LabelField title="Reviewed By" value={record.sOper} />
          <LabelField title="Recommendation" value={record.sOption} />
          {Str.strtolower(record.sOption) == "approve" ||
          Str.strtolower(record.sOption) == "approved" ? (
            <LabelField
              title="Approved Amount"
              value={record.iAmount}
              format="currency"
            />
          ) : (
            <></>
          )}
          {Str.strtolower(record.sOption) == "counter" ||
          Str.strtolower(record.sOption) == "countered" ? (
            <LabelField
              title="Countered Amount"
              value={record.iAmount}
              format="currency"
            />
          ) : (
            <></>
          )}
          {Str.strtolower(record.sOption) == "counter" ||
          Str.strtolower(record.sOption) == "countered" ||
          Str.strtolower(record.sOption) == "approve" ||
          Str.strtolower(record.sOption) == "approved" ? (
            <>
              <LabelField title="Term" value={record.iTerm} format="int" />
              <LabelField
                title="Interest Rate"
                value={record.iRate / 100}
                format="%"
              />
            </>
          ) : (
            <></>
          )}
          {Str.strtolower(record.sOption) == "decline" ||
          Str.strtolower(record.sOption) == "declined" ? (
            <LabelField title="Decline Reason" value={record.sAdverseAction} />
          ) : (
            <></>
          )}
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          {record.sComment && record.sComment.length > 0 ? (
            <LabelField
              title="Comment"
              value={record.sComment}
              format="richtext"
              titlePosition="top"
            />
          ) : (
            <></>
          )}
          {record.filelist && record.filelist.length > 0 ? (
            <LabelAttachedField list={record.filelist} titlePosition="top" />
          ) : (
            <></>
          )}
          {/* <ApplicationFilesLabel appId={appId} step='Initial Review' substep='All' /> */}
        </Grid>
      </Grid>
    </>
  );
};

export default InitialReview;
